"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _toDisplayCase = _interopRequireDefault(require("../toDisplayCase"));
var _excluded = ["type"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/Table/Head.js";
function Head(_ref) {
  var _this = this;
  var fields = _ref.fields,
    selectable = _ref.selectable,
    columns = _ref.columns,
    excludes = _ref.excludes,
    actionsList = _ref.actionsList,
    selected = _ref.selected,
    onSelectAll = _ref.onSelectAll,
    objects = _ref.objects;
  return /*#__PURE__*/_react["default"].createElement("tr", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 9
    }
  }, selectable && /*#__PURE__*/_react["default"].createElement("th", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    className: "align-middle",
    id: "check_all",
    checked: objects.length === selected.length && objects.length !== 0,
    onChange: function onChange(checked) {
      return onSelectAll(checked);
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 21
    }
  })), columns.map(function (field) {
    var _fields$field = fields[field],
      type = _fields$field.type,
      options = (0, _objectWithoutProperties2["default"])(_fields$field, _excluded);
    if (excludes.includes(field)) return null;
    var label = options.label || (0, _toDisplayCase["default"])(field);
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: field,
      className: "fs-xs align-middle text-nowrap",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24,
        columnNumber: 25
      }
    }, label);
  }), actionsList.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("th", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "50px"
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 25
    }
  })), /*#__PURE__*/_react["default"].createElement("th", {
    className: "fs-xs align-middle text-nowrap",
    colSpan: actionsList.length,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 21
    }
  }, "ACTIONS")));
}
var _default = exports["default"] = Head;